export const getShopAuthorizedLists = (state) => {

    return state.shopAuthorized

}